import {Injectable, OnDestroy} from '@angular/core';
import {ViewManagerService} from "../../services/view-manager.service";
import {Level, Message} from "../../model/message.component";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ResultCase} from "../../model/lookup-results.model";
import {map} from "rxjs/operators";
import {ChannelDefinition} from "../../model/channels.model";
import {BehaviorSubject} from "rxjs";

import 'reflect-metadata';
import {JsonProperty, ObjectMapper} from "json-object-mapper";

export class CaseFetchResponse {
  @JsonProperty({name: "selected"})
  public selected: ResultCase;

  @JsonProperty({name: "definition"})
  public definition: ChannelDefinition;
}

export class CaseResultsQuery {

  public id?: string = undefined;

  public batch?: string = undefined;

  public vertical?: string = undefined;

  public code?: string = undefined;

  public data?: string = undefined;

  public record?: string = undefined;

  public process?: string = undefined;

  public entity?: string = undefined;

  public report?: string = undefined;

  public status?: string = undefined;

}


@Injectable({
  providedIn: 'root'
})
export class AdminResultCaseService implements OnDestroy {

  query = new CaseResultsQuery();
  selected: ResultCase;
  definition: ChannelDefinition;

  resultsSubject = new BehaviorSubject<ResultCase[]>([]);

  constructor(
    private http: HttpClient,
    private viewManager: ViewManagerService,
  ) {
  }

  ngOnDestroy(): void {
    this.reset();
  }

  reset() {
    this.query = new CaseResultsQuery();
    this.resultsSubject = new BehaviorSubject<ResultCase[]>([]);
  }

  select(id: string) {
    const query = new CaseResultsQuery();
    query.id = id;
    this.http.post<Record<string, any>>(environment.apiPrefix + "/results/cases/fetch", query)
      .subscribe({
        next: (result) => {
          if (result) {
            this.selected = ObjectMapper.deserialize(ResultCase, result['selected'])
            this.definition = ObjectMapper.deserialize(ChannelDefinition, result['definition']);
          } else {
            this.viewManager.displayMessage(new Message("case not found, operation failed", new Level("warning")));
          }
        },
        error: error => {
          this.viewManager.displayMessage(new Message("machine stop, operation failed: " + error.error, new Level("error")));
        }
      });
  }

  search() {
    this.http.post(environment.apiPrefix + "/results/cases/search", this.query)
      .pipe(map(result => ObjectMapper.deserializeArray(ResultCase, (result as any).data)))
      .subscribe({
        next: (result) => {
          if (result && result.length > 0) {
            this.resultsSubject.next(result);
          } else {
            this.resultsSubject.next([]);
            this.viewManager.displayMessage(new Message("no results found", new Level("warning")));
          }
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")));
        }
      });
  }
}
